import React, { CSSProperties, ReactNode } from 'react';
import classNames from 'classnames';

type TemplatePageContainerProps = {
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
};

const TemplatePageContainer = ({
  children = null,
  className = '',
  style = {}
}: TemplatePageContainerProps) => {
  return (
    <div className={classNames('px-6 md:px-8', className)} style={style}>
      {children}
    </div>
  );
};

export default TemplatePageContainer;
